import environment from '../../environments';
import { authMethod } from './Auth.constants';
import { AuthMethod, AuthMethodId } from './Auth.interface';

/**
 * Resolved auth config.
 */
export const authConfig = (() => {
  const authConfig = environment.authConfig || {};
  const methods = Array.from(authConfig.methods || []);
  if (methods.length === 0) {
    methods.push(authMethod.default);
  }
  // get default method
  // fallback to default method if its included,
  // otherwise fallback to first method
  const defaultId = authConfig.defaultId || authMethod.default.id;
  const defaultMethod =
    methods.find(method => method.id === defaultId) || methods[0];
  // id -> auth method object, for faster lookup
  const methodMap = {} as Record<AuthMethodId, AuthMethod | undefined>;
  for (const method of methods) {
    methodMap[method.id] = method;
  }
  // handle showing auth methods if there are multiple methods
  // or if google auth method is included since a clicking the
  // rendered button is required to trigger the google login
  const multiple = !!(methods.length > 1 || methodMap[AuthMethodId.Google]);
  return { methods, methodMap, defaultMethod, multiple };
})();
